module.exports = __webpack_public_path__ + "static/media/webdesign-services-img24.675dfb4e.jpg";